
import React, { useState, useEffect } from 'react';
import { Assignment, FileCopySharp, Add } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';


//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { useParams } from 'react-router-dom';

//servicios
import { wsGet, wsUpdate, wsFindBy } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import { WithApp } from 'contexts/appContext';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'DocEntry', accessor: 'DocEntry'},
  { Header: 'Número Documento', accessor: 'DocNum'},
  { Header: 'Suma Aplicada', accessor: 'SumApplied'},
  { Header: 'Fecha Documento', accessor: 'DocDate'},
  { Header: 'Tipo Pago', accessor: 'TipoPago'},
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const { DocEntry } = useParams();
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);
  const [currentAccount, setAccount] = useState([]);
  const [respuestas, setRespuestas] = useState([]);


  async function loadCurrentAccount(Entry) {
    setDataLoading(true);
    let response = await wsGet('pymt/current-account', Entry);
    setDataLoading(false);
    if (response.success) {
      setAccount(response.data);
    }
  }

  async function listRespuestas() {
    setDataLoading(true);
    let response = await wsFindBy('pymt/current-account-detail', { DocEntry: DocEntry });
    setDataLoading(false);
    if (response.success) setRespuestas(response.data);
  }

  useEffect(() => {
    loadCurrentAccount(DocEntry);
    listRespuestas();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado Detallado de Cuentas Corrientes
            <span style={{ fontSize: '14px' }}>
              <b>{` (${currentAccount.CardName || ''})`}</b>
            </span>
            {dataLoading && <LoadingSpinner />}
            </h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="listado_detallado_respuestas_supervisores"
              formatDate="DD-MM-YYYY"
              columns={columns}
              data={respuestas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                    </div>
                  ),
                  DocEntry: item.DocEntry,
                  DocNum: item.DocNum,
                  SumApplied: item.SumApplied,
                  DocDate: item.DocDate,
                  TipoPago: item.TipoPago,
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
